import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-align-center flex-center" }

import { onMounted } from "vue";
import MainHeader from "../common/MainHeader.vue";
import NotFound from "../common/NotFound.vue";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const Router = useRouter();
onMounted(() => {
  setTimeout(() => {
    Router.replace("/");
  }, 2000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainHeader),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(NotFound, { "empty-text": "页面找不到..." })
    ])
  ], 64))
}
}

})